<template>
  <div class="switch inline left txt-center" :class="{checkbox: checkbox, disabled: disabled, TA:isTestAchat}">
    <div
      class="item"
      :class="{active: checked(possibleValue.value)}"
      v-for="possibleValue in possibleValues"
      :key="possibleValue.value"
      @click="click(possibleValue.value)"
    ><span>{{ possibleValue.label }}</span></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters("subscription", ["isTestAchat"])
  },
  props: {
    possibleValues: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Object, Boolean, Number, Array],
      required: false,
    },
    checkbox: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    checked(value) {
      if(this.checkbox) {
        return this.value.indexOf(value) >= 0
      } else 
        return this.value !== null && this.value === value;
    },
    click(value) {
      if(!this.disabled) {
        if(this.checkbox) {
          let array = Object.assign(this.value);
          let index = array.indexOf(value);

          if(index === -1) {
            array.push(value);
          } else {
            array.splice(index, 1);
          }

          this.$emit('input', array);
        } else {
          this.$emit('input', value);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.switch {
  width: auto;
  align-items: stretch; 
  font-size: 0.9rem;

  .item {
    cursor: pointer;
    // flex: 1;
    padding: 6px 0px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 20px;
    max-width: 100%;
    
    span {
      text-align: left;
      flex: 1;
    }

    &:last-child { margin-right: 0; }

    &::before {
      content: '';
      height: 16px;
      width: 16px;
      border: 2px solid $grey;
      border-radius: 50%;
      margin-right: 10px;
    }

    &.active {
      font-weight: 500;

      &::before {
        content: '';
        height: 13px;
        width: 13px;
        border: 2px solid #fff;
        background: $clearYellow;
        margin-right: 13px;
        box-shadow: 0px 0px 0px 2px $yellow;
      }
    }
  }

  &.checkbox {
    .item {
      &::before { border-radius: 4px; }
      &.active::before {
        height: 16px;
        width: 16px;
        border: 2px solid $yellow;
        box-shadow: none;
        margin-right: 10px;
        background:url("~@/assets/icons/icon-check.svg") no-repeat center/14px 14px $yellow;
      }
    }
    
    &.disabled .item {
      &::before {
        border: 2px solid $middleGrey;
        background: $middleGrey;
      } 
      &.active::before {
        border: 2px solid $middleGrey;
        background:url("~@/assets/icons/icon-check.svg") no-repeat center/14px 14px $middleGrey;
      }
    }
  }
}

.TA {
  .item {
    &.active {
      font-weight: 500;

      &::before {
        content: '';
        border: 2px solid #fff;
        box-shadow: 0px 0px 0px 2px $pink;
        background: $pink;
      }
    }
  }

  &.checkbox {
    .item {
      &.active::before {
        border: 2px solid $black;
        background:url("~@/assets/icons/icon-check-white.svg") no-repeat center/14px 14px $black;
      }
    }
  }
}
</style>

// <style lang="scss" scoped>
// .switch {
//   border: 2px solid $yellow;
//   border-radius: 4px;
//   width: auto;
//   align-items: stretch; 
//   font-size: 0.9rem;

//   .item {
//     cursor: pointer;
//     flex: 1;
//     padding: 6px 10px;
//     border-left: 2px solid $yellow;
//     display: flex;
//     flex-direction: column;
//     justify-content: center;

//     &:first-child {
//       border: 0;
//     }

//     &.active {
//       font-weight: 500;
//       background: $clearYellow;
//     }
//   }
// }
// </style>


// WEBPACK FOOTER //
// src/components/Form/BecomeFields/SwitchField.vue